import { TravelDirectionEnum } from '@wilson/activities/symbols';
import { Base } from '@wilson/base';
import { ActivityTemplateQualificationV2 } from '../activity-qualifications-v2/ActivityTemplateQualificationV2';
import type { ActivityTemplateQualifications } from '../activity-qualifications/ActivityTemplateQualification';
import type { Agreement } from '../agreements/agreement';
import { GeoLocation } from '../locations/geoLocation';
import { Profession } from '../profession/profession';
import { SeriesRuleV2 } from '../series-rule-v2/series-rule-v2';
import type { ServiceSeries } from '../services/serviceSeries';
import { WeekDaysEnum } from '../services/weekDays';
import { ShiftSeries } from '../shifts/shiftSeries';
import type { Job } from '../wilson-share/job';
import { ActivityCategory } from './activity-category';
import { Store } from '@ngxs/store';

export interface ActivityTemplate extends Base {
  name: string;
  startDatetime: string;
  endDatetime: string;
  activityCategoryId: string;
  startLocationId: string;
  endLocationId: string;
  viaLocationIds: string[];
  shiftSeriesId: string | null;
  serviceSeriesId: string | null;
  startTimeZone: string;
  endTimeZone: string;
  cargo: string | null;
  track: string | null;
  note: string | null;
  orderNumber: string | null;
  wagonNumber: string | null;
  locomotiveNumber: string | null;
  externalNumber: string | null;
  numberOfWagons: number | null;
  tonnage: number | null;
  vehicleEmissionClassId: number | null;
  travelDirection: TravelDirectionEnum | null;
  validateRoute?: boolean;

  activityCategory?: ActivityCategory;
  startLocation?: GeoLocation | null;
  endLocation?: GeoLocation | null;
  serviceSeries?: ServiceSeries;
  shiftSeries?: ShiftSeries;
  viaLocations?: GeoLocation[];
  activityTemplateQualifications?:
    | Partial<ActivityTemplateQualifications>[]
    | null;
  activityTemplateQualificationsV2?:
    | Partial<ActivityTemplateQualificationV2>[]
    | null;
  agreementId?: string | null;
  agreement?: Agreement;
  professionId?: string | null;
  profession?: Profession;
  jobActivityTemplates?: JobActivityTemplate[];
  organizationalUnitTransportGoodsId?: number;
  priority?: number | null;
  seriesRules?: SeriesRuleV2[];
}

export interface JobActivityTemplate {
  activityTemplateId: string;
  activityTemplate?: ActivityTemplate;
  jobId: string;
  job?: Job;
  recurringOn: WeekDaysEnum[];
  validFrom: string;
  validTill: string;
}

export type CheckedActivityTemplate = ActivityTemplate & {
  isChecked: boolean;
};

export function filterTemplatesNotYetInBucketOrJob(
  activityTemplates: ActivityTemplate[],
  jobBucketItemIds: string[],
): ActivityTemplate[] {
  return activityTemplates.filter(
    (template) =>
      !jobBucketItemIds.includes(template.id as string) &&
      !template.jobActivityTemplates?.length,
  );
}
